import request from '@/utils/request'

/**
 * 查询场景元件
 * @param {Object} params
 * @returns
 */
export function listSceneModelDefinition(params) {
  return request({
    url: '/model_definition/scene_definition/list',
    method: 'GET',
    params
  })
}

/**
 * 添加场景元件
 * @param {Object} data
 * @returns
 */
export function addSceneModelDefinition(data) {
  return request({
    url: '/model_definition/scene_definition/insert',
    method: 'POST',
    data
  })
}

/**
 * 修改场景元件
 * @param {Object} data
 * @returns
 */
export function updateSceneModelDefinition(data) {
  return request({
    url: '/model_definition/scene_definition/update',
    method: 'POST',
    data
  })
}

/**
 * 删除
 * @param {Object} data
 * @returns
 */
export function removeSceneModelDefinition(data) {
  return request({
    url: '/model_definition/scene_definition/remove',
    method: 'POST',
    data
  })
}

/**
 * 添加场景元件
 * @param {Object} data
 * @returns
 */
export function getSceneModelDefinitionById(data) {
  return request({
    url: '/model_definition/scene_definition/getById',
    method: 'get',
    data
  })
}
